import React from 'react';
import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import ListItemAvatar1 from 'Components/ComponentLibrary/Components/Uncategorized/ListItemAvatar/ListItemAvatar1';
import ImageAvatar from 'Views/Onboarding/Components/ImageAvatar';
import IconAvatar from 'Views/Onboarding/Components/IconAvatar';
import MonotoneIconAvatar from './MonotoneIconAvatar';

const AvatarPicker = ({ resource, ...rest }) => {
  return pickFunction(resource, {
    [fr.relationships.image.name]: () => {
      return (
        <ListItemAvatar1>
          <ImageAvatar
            resource={resource}
            {...rest}
          />
        </ListItemAvatar1>
      );
    },
    [fr.relationships.icon.name]: () => {
      return (
        <ListItemAvatar1>
          <IconAvatar
            src={resource.relationship(fr.relationships.icon.name).link('related').url()}
            {...rest}
          />
        </ListItemAvatar1>
      );
    },
    [fr.relationships.monotoneIcon.name]: () => {
      return (
        <ListItemAvatar1>
          <MonotoneIconAvatar
            src={resource.relationship(fr.relationships.monotoneIcon.name).link('related').url()}
            {...rest}
          />
        </ListItemAvatar1>
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default AvatarPicker;
